import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

type Props = {
  children: React.ReactNode;
};

const MainLayout = ({ children }: Props) => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden">
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 15% 10%, var(--glow-gold), transparent 25%), radial-gradient(circle at 85% 18%, var(--glow-green), transparent 24%), radial-gradient(circle at 80% 82%, var(--glow-soft), transparent 20%)",
        }}
      />
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[28rem]"
        style={{
          background:
            "linear-gradient(180deg, color-mix(in srgb, var(--text-strong) 8%, transparent), transparent)",
        }}
      />
      {/* Hide Navbar only on the home page */}
      {!isHome && <Navbar />}
      <main
        className={`relative z-10 flex-1 ${isHome ? "px-0" : "px-4 md:px-8"}`}
      >
        {children}
      </main>
      {!isHome && <Footer />}
    </div>
  );
};

export default MainLayout;
